module.exports = __webpack_public_path__ + "media/images/redrock/sncc_logo-eb2ada1ab3c493f1a96ac4ea77462541.png";